import React, { useEffect } from 'react';
import classes from './Home12Contact.module.scss';
import { Link } from 'react-router-dom';
import Home12Header from './Home12Header';
import Home12LeadForm from './Home12LeadForm';

const Home12Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={classes.root}>
            <Home12Header mode="fixed" />

            <main className={classes.mainContent}>
                <div className={classes.container}>
                    <Home12LeadForm mode="contact" classes={classes} />

                    <div className={classes.infoWrapper}>
                        <div className={classes.infoPanel}>
                            <img src="/react-assets/home10/home10-feature-support.jpg" alt="オンライン相談のサポートイメージ" className={classes.infoImage} />
                            <div className={classes.infoContent}>
                                <h3>オンライン相談について</h3>
                                <p>システム導入やDX化についての漠然としたお悩みでも構いません。専門スタッフが御社の課題をヒアリングし、最適なご提案をいたします。</p>
                                <ul className={classes.infoList}>
                                    <li><span className={classes.checkIcon}>✓</span> ZoomまたはGoogle Meetを使用</li>
                                    <li><span className={classes.checkIcon}>✓</span> 相談時間は約30分〜1時間</li>
                                    <li><span className={classes.checkIcon}>✓</span> ご相談は完全無料</li>
                                </ul>
                                <div className={classes.infoContactBox}>
                                    <p className={classes.contactLabel}>お電話でのお問い合わせ</p>
                                    <p className={classes.contactPhone}>076-287-0026</p>
                                    <p className={classes.contactTime}>営業時間: 平日 10:00〜18:00</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <footer className={classes.footer}>
                <div className={classes.footerLinks}>
                    <Link to="/privacy">プライバシーポリシー</Link>
                </div>
                <div className={classes.companyInfo}>
                    <p>&copy; {new Date().getFullYear()} collabo Inc.</p>
                </div>
            </footer>
        </div>
    );
};

export default Home12Contact;
